import CheckBasketItemsAvailable from "../../functions/CheckBasketItemsAvailable.js";

function communityDocumentName(location) {
  return [location.firstName, location.lastName, location.userId].join("");
}

function removePickupLocation(profile) {
  delete profile.pickupLocation;
  profile.basketItems = [];
  return profile;
}

function isApprovedCommunityMember(location, userId) {
  return (
    !location.hidden &&
    (location.communityHubType === "publicNoApproval" ||
      location.approvedCommunityMembers?.includes(userId))
  );
}

async function loadPickupLocation(database, location, readCommunityLocation) {
  if (location.pickupLocation) {
    const document = await readCommunityLocation(location);
    return document.exists ? { ...document.data() } : undefined;
  }

  const document = await database
    .collection("DistributionLocations")
    .doc("Vancouver")
    .get();
  const currentLocation = document.exists
    ? document.data()[location.name]
    : undefined;

  return currentLocation && currentLocation.status !== "inactive"
    ? { ...currentLocation, name: location.name }
    : undefined;
}

// This only prepares account data. The caller decides whether the authenticated
// user is still current before publishing the result to the app.
export default async function loadAccountData(database, profile) {
  const account = {
    ...profile,
    basketItems: [...(profile.basketItems || [])],
  };
  const communityDocuments = new Map();
  const readCommunityLocation = (location) => {
    const name = communityDocumentName(location);
    if (!communityDocuments.has(name)) {
      communityDocuments.set(
        name,
        database.collection("CommunityLocations").doc(name).get(),
      );
    }
    return communityDocuments.get(name);
  };

  if (account.farms === undefined && account.userType !== "individual") {
    account.farms = ["No farms available please contact developer"];
  }

  if (account.communityLocation) {
    const document = await readCommunityLocation(account.communityLocation);
    if (document.exists) {
      account.communityLocation = { ...document.data() };
    }
  }

  if (account.userType !== "individual") {
    return account;
  }

  if (!account.pickupLocation) {
    account.basketItems = [];
    return account;
  }

  const isCommunityPickup = Boolean(account.pickupLocation.pickupLocation);
  const pickupLocation = await loadPickupLocation(
    database,
    account.pickupLocation,
    readCommunityLocation,
  );
  if (!pickupLocation) {
    return removePickupLocation(account);
  }

  account.pickupLocation = pickupLocation;
  CheckBasketItemsAvailable(account);

  if (
    isCommunityPickup &&
    !isApprovedCommunityMember(pickupLocation, account.userId)
  ) {
    delete account.pickupLocation;
  }

  return account;
}
